<template>
  <div id="projmap"></div>
</template>

<script>
import axios from 'axios'

export default {
  name: "proj_map",
  data() {
    return {
      icon_src: require("../../assets/map_on.png")
    }
  },
  mounted() {
    let project_id = this.$route.query.proj_id
    let proj_info = [];
    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    // axios.post(this.$store.getters.getBesServer + "ProjInfoByComp", postData).then(resp => {
    axios.post(this.$store.getters.getBesServer + "DashbProjInfoByComp", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      if (errNo == "0") {
        var projects = resp.data.result;
        console.log('projects.....', projects)
        let lastInfoW = null
        for (i in projects) {
          var lat = ""; //纬度
          var lon = ""; //经度
          var lon_lat = projects[i].lon_lat
          if (null != lon_lat && lon_lat.length > 0) {
            lat = lon_lat.split(",")[1]
            lon = lon_lat.split(",")[0]
            proj_info[i] = [lon, lat, projects[i].project_name, 'Project Progess:' + projects[i].progress + '%',
              'Structural:' + projects[i].structural + '%', 'Architectural:' + projects[i].arch_progress + '%',
              "M&E:" + projects[i].me_progress + '%', "Project Start Date:" + projects[i].construction_start, "Project End Date:" + projects[i].construction_end,
              "Project GFA:" + projects[i].program_gfa + '㎡', "Project Contract Sum:" + projects[i].program_amount + '$', "Project Developer:" + projects[i].developer_client,
              "Project Consultant:" + projects[i].consultant,
              '\#\/dashboard\?proj_id\=' + projects[i].cms_projid];
          } else {
            proj_info[i] = ["", "", projects[i].project_name, 'Project Progess:' + projects[i].progress + '%',
              'Structural:' + projects[i].structural + '%', 'Architectural:' + projects[i].arch_progress + '%',
              "M&E:" + projects[i].me_progress + '%', "Project Start Date:" + projects[i].construction_start, "Project End Date:" + projects[i].construction_end,
              "Project GFA:" + projects[i].program_gfa + '㎡', "Project Contract Sum:" + projects[i].program_amount + '$', "Project Developer:" + projects[i].developer_client,
              "Project Consultant:" + projects[i].consultant,
              '\#\/dashboard\?proj_id\=' + projects[i].cms_projid];
          }
        }
        let map = new google.maps.Map(document.getElementById('projmap'), {
          zoom: 11,
          center: {lat: 1.352, lng: 103.819}  //新加坡市
        });
        map.setCenter({
          lng: parseFloat(proj_info[0][0]),
          lat: parseFloat(proj_info[0][1])
        })
        //添加地图类型控件
        for (var i = 0; i < proj_info.length; i++) {
          let marker = new google.maps.Marker({
            position: {
              lng: parseFloat(proj_info[i][0]),
              lat: parseFloat(proj_info[i][1])
            },
            icon: require("../../assets/map_on.png")
          })
          let content = '<div style="margin:0;padding:2px; width: 500px;height: 260px">' +
            '<h4 style="margin-top: 5px;">' + proj_info[i][2] + '</h4>' +
            //'<img src="../../assets/project.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin:5px;"/>' +
            '<div style="margin-left: 60px"><div style="float:left;margin-right: 100px;text-align: left"><p>' + proj_info[i][3] + '</p><p>' + proj_info[i][4] + '</p><p>' + proj_info[i][5] + '</p><p>' + proj_info[i][6] + '</p><p>' +
            proj_info[i][9] + '</p></div>' +
            '<div style="float:left;text-align: left"><p>' + proj_info[i][7] + '</p><p>' + proj_info[i][8] + '</p><p>' + proj_info[i][10] + '</p><p>' +
            proj_info[i][11] + '</p><p>' + proj_info[i][12] + '</p></div></div>' +
            '<button style="margin-top: 1%;border-width: 0px;height: 30px;width: 60%;iborder-width:0px;border-radius: 5px;background: #62a39f;color: #dfe3e5;font-family: \'Microsoft YaHei\'" onclick="location=\'' + proj_info[i][13] + '\'">Project Dashboard</button>' +
            '</div>';
          let infoWindow = new google.maps.InfoWindow({
            content: content
          })
          google.maps.event.addListener(marker, 'click', function () {
            var position = marker.position.toString()
            var zoom = map.getZoom()
            var latLng = position.substring(1, position.length - 1).split(',')
            var lat = (parseFloat(latLng[0].trim()) + parseFloat(0.46 / (zoom + 1))).toString() //地图中心比marker稍向北一点
            var lng = latLng[1].trim()
            var position1 = {
              lat: parseFloat(lat.substring(0, lat.indexOf('.') + 4)),  //小数点后三位
              lng: parseFloat(lng.substring(0, lng.indexOf('.') + 4))
            }
            map.panTo(position1)
            infoWindow.open(map, marker)
            if (lastInfoW) {
              lastInfoW.close();
            }
            if (infoWindow == lastInfoW) {
              lastInfoW = null
            } else {
              lastInfoW = infoWindow
            }
          })
          google.maps.event.addListener(map, 'click', function () {
            if (lastInfoW) {
              lastInfoW.close()
              lastInfoW = null
            }
          })
          marker.setMap(map)
        }
      } else if (errNo == "7") {
        alert("No Projects!")
      } else {
        alert("DashbProjInfoByComp.error:" + errStr)
      }
    }).catch(error => {
      alert("DashbProjInfoByComp.error:" + error)
    })
  }
}
</script>

<style scoped>
#projmap {
  /*width: 1920px;*/
  /*height: 900px;*/
  width: 100%;
  height: 100%;
  margin: 0px auto;
  font-family: "Microsoft YaHei"
}
</style>



// WEBPACK FOOTER //
// src/components/proj_map/proj_map.vue